import rpcCall, {longRpcCall} from '../../../util/rpc/rpcCalls'

const MAX_CHUNK_SIZE = 200

export default class BulkOperationsController {
    constructor({
        method,
        initialResult,
        combineFn = () => {},
        onProgress = () => {},
        onSuccess = () => {},
        onFailure = () => {},
    }) {

        this.params = {
            method,
            initialResult,
            combineFn,
            onProgress,
            onSuccess,
            onFailure,
        }
    }

    processItems(items, args, operationIdRequired = false) {
        let index = 0
        let result = this.params.initialResult

        let methodParams = operationIdRequired ? [...args, null] : args

        const makeRpcCall = () => {
            const chunk = items.slice(index, index + MAX_CHUNK_SIZE)

            longRpcCall(this.params.method, [chunk, ...methodParams], error => this.params.onFailure(error))
                .then(chunkResult => {
                    index += MAX_CHUNK_SIZE
                    result = this.params.combineFn(result, chunkResult)

                    if (operationIdRequired && chunkResult.operationId)
                        methodParams = [...args, chunkResult.operationId]

                    const percent = Math.trunc(Math.min((index / items.length) * 100, 100))
                    this.params.onProgress(percent)

                    if (index < items.length)
                        makeRpcCall()
                    else
                        this.params.onSuccess(result)
                })
                .catch(error => {
                    // errors handled in errorHandler
                })
        }

        makeRpcCall()
    }
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/bulkOperations/controller/BulkOperationsController.js